<template>
  <div class="main_div_bg">
    <img src="../../../static/img/bg_callus.jpg" class="img_bg" />
    <div class="father_div_bg">
      <el-row :gutter="40" class="center_div_bg">
        <el-col :xs="24" :sm="24" :md="5" :lg="5">
          <div>
            <div class="call_div_bg">
              <p class="big_title">
                {{ language == "zh" ? "联系我们" : "Contact us" }}
              </p>
              <el-menu
                :default-active="menuPosition"
                class="el-menu-vertical-demo"
                @open="handleOpen"
                @close="handleClose"
                @select="handleSelect"
              >
                <el-menu-item :index="0">
                  <span slot="title">{{
                    language == "zh" ? "联系方式" : "Contact Info"
                  }}</span>
                </el-menu-item>
                <el-menu-item :index="1">
                  <span slot="title">{{
                    language == "zh" ? "招聘信息" : "Recruitment"
                  }}</span>
                </el-menu-item>
                <el-menu-item :index="i + 2" v-for="(item, i) in menu" :key="i">
                  <span slot="title">{{
                    language == "zh" ? item.type : item.typeEn
                  }}</span>
                </el-menu-item>
              </el-menu>
            </div>
            <div class="menu callus show_pc">
              <div class="text">
                {{ language == "zh" ? "联系我们" : "Contact us" }}
              </div>
              <div class="tel">
                <img src="../../../static/img/50.png" /> {{ contact.tel }}
              </div>
              <div class="email">
                <img src="../../../static/img/49.png" />{{ contact.email }}
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="19" :lg="19">
          <div class="call_div_bg">
            <MapView v-if="menuPosition == 0" :language="language"></MapView>
            <JobView
              v-else-if="menuPosition == 1"
              :language="language"
              ref="JobView"
            ></JobView>
            <MoreView
              v-show="menuPosition > 1"
              ref="MoreView"
              :detail="detail"
              :detailEn="detailEn"
              :language="language"
            ></MoreView>
          </div>
        </el-col>
      </el-row>
      <div class="Mymenu callus show_phone">
        <div class="text">
          {{ language == "zh" ? "联系我们" : "Contact us" }}
        </div>
        <div class="tel">
          <img src="../../../static/img/50.png" /> {{ contact.tel }}
        </div>
        <div class="email">
          <img src="../../../static/img/49.png" />{{ contact.email }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MapView from "./Map.vue";
import JobView from "./Job.vue";
import MoreView from "./More.vue";
export default {
  components: {
    MapView,
    JobView,
    MoreView,
  },
  props: {
    language: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      tabPosition: "left",
      menuPosition: 0,
      htmlID: "1",
      menu: [],
      contact: {},
      detail: "",
      detailEn: "",
    };
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      if (to.fullPath.indexOf("CallUs") >= 0) {
        this.getInfo();
        this.getInfo2();

        this.menuPosition = localStorage.getItem("callus_menu_position") || 0;
        console.log("route==" + this.menuPosition);
      }
    },
  },
  mounted() {
    this.menuPosition = localStorage.getItem("callus_menu_position") || 0;
    this.getInfo();
    this.getInfo2();
    console.log("mounted==" + this.menuPosition);
  },

  methods: {
    handleOpen() {},
    handleClose() {},
    handleSelect(index, indexPath) {
      console.log(index);
      this.menuPosition = index;
      localStorage.setItem("callus_menu_position", index);
      if (index == 1) {
        this.$refs.JobView.job_content=""//再次点击则返回列表
      }
      if (index >= 2 && this.$refs.MoreView) {
        // this.currentPage = 1;
        // this.getInfo1(this.menu[index - 3].id);
        this.$refs.MoreView.getHtml(this.menu[index - 2].id);
      }
    },
    getInfo() {
      this.$http
        .get("/hdbs/api/activity/type/list", {
          params: {
            parentType: "联系我们",
          },
        })
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              this.menu = response.data.data.filter((x) => {
                return x.parentType == "联系我们";
              });
              if (this.menuPosition >= 2 && this.$refs.MoreView) {
                this.$refs.MoreView.getHtml(
                  this.menu[this.menuPosition - 2].id
                );
              }
            }
          }.bind(this)
        );
    },
    getInfo1(type) {
      this.$http
        .get("/hdbs/api/contacts/info/" + type, {
          params: {
            page: this.currentPage,
            limit: 11,
          },
        })
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              this.detail = response.data.data.content;
              this.detailEn = response.data.data.contentEn;
            }
          }.bind(this)
        );
    },
    getInfo2() {
      this.$http.get("/hdbs/api/contacts/company", {}).then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.contact = response.data.data[0];
          }
        }.bind(this)
      );
    },
  },
};
</script>
<style lang="stylus" scoped>
.main_div_bg {
  // margin-top calc(-65px - 6vh)
}

.img_bg {
  margin-top: calc(-65px - 6vh);
  object-fit: cover;
  width: 100%;
}

.father_div_bg {
  padding: 0 20rem;
  border-radius: 6px;
  background: #fff;
  height: 100%;
  background-image: url('../../../static/img/Background4.jpg');
  background-repeat: round;
}

.center_div_bg {
  padding: 6vh 0;
}

.call_div_bg {
  padding: 3.5rem 4.5rem;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.12);
  font-size: 1.7rem;
  margin-bottom: 3rem;

  .big_title {
    color: var(--mainBlue);
    margin-bottom: 3rem;
    font-size: 2.7rem;
    font-family: Demibold;
  }

  .title {
    color: var(--mainBlue);
    margin-bottom: 3rem;
    margin-left: 2.5rem;
  }

  .text {
    color: var(--mainGary);
  }

  .text2 {
    color: var(--mainGary);
    margin-left: 2.5rem;
  }

  .icon {
    width: 1.7rem;
    height: 1.7rem;
    margin-right: 1rem;
  }
}

.el-menu {
  border-right: none;
}

.el-menu-item {
  margin-bottom: 1rem;
  padding-left: 0 !important;
  font-size: 1.7rem;
  font-family: Regular;
  color: var(--mainGary);
  height: auto;
  line-height: normal;
}

.el-menu-item.is-active {
  color: var(--mainBlue);
  background-color: #fff;
}

.el-menu-item:hover {
  outline: 0;
  background-color: #fff;
}

.callus {
  margin-top: 3rem;
  padding: 3.5rem 2rem;
  font-size: 1.7rem;

  .text {
    color: #024580;
    margin-bottom: 2rem;
    margin-left: 2.5rem;
  }

  .tel {
    display: flex;
    align-items: center;

    img {
      width: 17px;
      margin-right: 5px;
    }
  }

  .email {
    display: flex;
    align-items: center;

    img {
      width: 17px;
      margin-right: 5px;
    }
  }
}

.menu {
  padding: 3.5rem 2rem;
  background: #fff;
  border-radius: 6px;
  font-size: 1.7rem;
  margin-bottom: 3rem;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.12);
}

.show_pc {
  display: block;
}

.show_phone {
  display: none;
}

.Mymenu {
  padding: 3.5rem 2rem;
  background: #fff;
  border-radius: 6px;
  font-size: 1.7rem;
  margin-bottom: 3rem;
  margin-left: 1rem;
  margin-right: 1rem;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.12);

  .biaoti {
    color: var(--mainBlue);
    margin-bottom: 3rem;
    font-size: 2.7rem;
    margin-left: 2.5rem;
    font-family: Demibold;
  }
}

@media screen and (max-width: 1200px) {
  .center_div_bg {
    padding: 1rem;
  }

  .father_div_bg {
    padding: 0;
  }

  .show_pc {
    display: none;
  }

  .show_phone {
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/CallUs/CallUs.vue